import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { isNativeApp } from './lib/platform';
import App from './App';
import { AuthProvider } from './lib/AuthContext';
import { I18nProvider } from './lib/i18n';
import { ThemeProvider } from './lib/theme';
import { ConfirmProvider } from './lib/ConfirmDialog';
import { ToastProvider } from './lib/Toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <I18nProvider>
        <ConfirmProvider>
          <ToastProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ToastProvider>
        </ConfirmProvider>
      </I18nProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// Register the service worker so the app can be installed as a PWA and
// boot offline. Only run in production builds — during `npm start` CRA
// hot-reloads aggressively and a SW would just get in the way.
if (isNativeApp) {
  // Native-feel styling hooks (see index.css .native-app rules).
  document.documentElement.classList.add('native-app');
}

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL || ''}/service-worker.js`)
      // eslint-disable-next-line no-console
      .catch((err) => console.warn('[sw] registration failed:', err));
  });
}
